export const softSkills = [
	{
		id: 1,
		title: 'Automotivación',
	},
	{
		id: 2,
		title: 'Asertividad',
	},
	{
		id: 3,
		title: 'Colaboración',
	},
	{
		id: 4,
		title: 'Cooperación',
	},
	{
		id: 5,
		title: 'Comprensión',
	},
	{
		id: 6,
		title: 'Dedicación',
	},
	{
		id: 7,
		title: 'Empatía',
	},
	{
		id: 8,
		title: 'Liderazgo',
	},
	{
		id: 9,
		title: 'Escucha activa',
	},
	{
		id: 10,
		title: 'Flexibilidad',
	},
	{
		id: 12,
		title: 'Responsabilidad',
	},
	{
		id: 13,
		title: 'Resiliente',
	},
	{
		id: 15,
		title: 'Tenacidad',
	},
];
